import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { EquipementData } from "../../../api/EquipementData";
import semat from "../../../assets/imgs/logo/semat.png";
import gehl from "../../../assets/images/partners/gehl.webp";
import MobileMenu from "./components/MobileMenu";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

import "./Header.css";
import { BtpData } from "../../../api/BtpData";
import { NetoyageData } from "../../../api/NetoyagaData";
import AUTRES_GIPH from "../../../assets/gif/autres.gif";
import GEHL_GIPH from "../../../assets/gif/gehl.gif";

const Header = () => {
  const [scroll, setScroll] = React.useState(0);
  const [path, setPath] = React.useState("");
  const location = useLocation();

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    setPath(location.pathname);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location]);

  const className =
    scroll > 80
      ? "fixed-navbar animated fadeInDown active"
      : "fixed-navbar fixed-header";

  let NonHomeStyle =
    location.pathname === "/" || location.pathname === "/others/"
      ? ""
      : "non_home_style";

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={className}>
      <header id="header">
        <div className={`wpo-site-header header-style-1 ${NonHomeStyle} `}>
          <nav className="navigation navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                  <div className="mobail-menu">
                    {" "}
                    <MobileMenu />{" "}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="navbar-header">
                    <Link
                      onClick={ClickHandler}
                      className="navbar-brand"
                      to="/"
                    >
                      {path.includes("others") && (
                        <img
                          style={{ marginBottom: "12px", marginTop: "12px" }}
                          src={semat}
                          className="semat-logo"
                          alt="semat"
                        />
                      )}

                      {!path.includes("others") && (
                        <img src={semat} className="semat-logo" alt="semat" />
                      )}
                    </Link>
                    {!path.includes("others") && (
                      <div className="navbar-brand">
                        <a
                          rel="noreferrer"
                          href="https://www.gehl.com/fr-FR"
                          target="_blank"
                        >
                          <img src={gehl} alt="semat" className="gehl-logo" />
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-8 col-md-2 col-2">
                  <div
                    id="navbar"
                    className="collapse navbar-collapse navigation-holder"
                  >
                    <button className="menu-close">
                      <i className="ti-close"></i>
                    </button>
                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                      {!path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink onClick={ClickHandler} to="/">
                            Accueil
                          </NavLink>
                        </li>
                      )}
                      {path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink onClick={ClickHandler} to="/others/">
                            Accueil
                          </NavLink>
                        </li>
                      )}

                      {!path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink onClick={ClickHandler} to="/equipement">
                            Equipement
                          </NavLink>
                          <ul className="sub-menu">
                            {EquipementData.map((equipement) => (
                              <li key={equipement.id}>
                                <NavLink
                                  onClick={ClickHandler}
                                  to={`/equipement/single/${equipement.id}`}
                                >
                                  {equipement.title}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}

                      {!path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink onClick={ClickHandler} to="/accesoires/1">
                            Accesoires
                          </NavLink>
                        </li>
                      )}

                      {path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink onClick={ClickHandler} to="/others/btp">
                            BTP
                          </NavLink>
                          <ul className="sub-menu">
                            {BtpData.map((btp) => (
                              <li key={btp.id}>
                                <NavLink
                                  onClick={ClickHandler}
                                  to={`/others/btp/single/${btp.id}`}
                                >
                                  {btp.title}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}

                      {path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink
                            onClick={ClickHandler}
                            to="/others/nettoyage"
                          >
                            Nettoyage
                          </NavLink>
                          <ul className="sub-menu">
                            {NetoyageData.map((net) => (
                              <li key={net.id}>
                                <NavLink
                                  onClick={ClickHandler}
                                  to={`/others/nettoyage/single/${net.id}`}
                                >
                                  {net.title}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}
                      {path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink
                            onClick={ClickHandler}
                            to="/others/autre_accesoires/1"
                          >
                            Accesoires
                          </NavLink>
                        </li>
                      )}
                      {path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink onClick={ClickHandler} to="/others/about">
                            A propos de nous
                          </NavLink>
                        </li>
                      )}
                      {!path.includes("others") && (
                        <li className="menu-item-has-children">
                          <NavLink onClick={ClickHandler} to="/about">
                            A propos de nous
                          </NavLink>
                        </li>
                      )}

                      {path.includes("others") && (
                        <li>
                          <NavLink onClick={ClickHandler} to="/others/contact">
                            Contactez-Nous
                          </NavLink>
                        </li>
                      )}

                      {!path.includes("others") && (
                        <li>
                          <NavLink onClick={ClickHandler} to="/contact">
                            Contactez-Nous
                          </NavLink>
                        </li>
                      )}
                      {!path.includes("others") && (
                        <li className="others_route">
                          <Link onClick={ClickHandler} to="/others/">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            Autre Partenaires
                          </Link>
                          <ul className="sub-menu">
                            <img
                              src={AUTRES_GIPH}
                              alt="semat"
                              width="280"
                              height="132"
                            />
                          </ul>
                        </li>
                      )}

                      {path.includes("others") && (
                        <li className="others_route">
                          <Link onClick={ClickHandler} to="/">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            GEHL
                          </Link>
                          <ul className="sub-menu">
                            <img
                              src={GEHL_GIPH}
                              alt="semat"
                              width="280"
                              height="132"
                            />
                          </ul>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
